
import vueTelegramLogin from './vue-telegram-login.vue'
export default {
  components: {
    'vue-telegram-login': vueTelegramLogin
  },
  data() {
    return {
      // loginData: [
      //   { icon: require('../../assets/img/login/mFacebook.svg'), url: null, name: this.$v('通过 Facebook 继续'), type: 2 },
      //   { icon: require('../../assets/img/login/mGoogle.svg'), name: this.$v('通过 Google 继续'), type: 3 },
      //   { icon: require('../../assets/img/login/mAppleID.svg'), name: this.$v('通过 Apple 继续'), type: 4 },
      //   { icon: require('../../assets/img/login/mTwitter.svg'), name: this.$v('通过 Telegram 登录'), type: 7 },
      //   { icon: require('../../assets/img/login/mLinkedin.svg'), name: this.$v('通过 linkedIn 登录'), type: 8 }
      // ],
      clientId: '720725194691-5mlhk8dgsc12gg9409g8bthqhhras28p.apps.googleusercontent.com',
      googleBtnConfigs: {
        type: 'standard',
        shape: 'rectangular',
        theme: 'outline',
        text: 'continue_with',
        size: 'large',
        locale: 'es-419',
        logo_alignment: 'left',
        width: 279
        // locale: "zh_CN"
      },
      LanguageCode: this.$store.state.LanguageCode // 当前页面语言
    }
  },
  computed: {
    loginData() {
      const isCn = this.$store.state.myCountry != 'cn'
      if (isCn && this.$store.state.host.includes('wikifx.com')) {
        return [
          // 登录方式
          {
            icon: require('../../assets/img/login/mFacebook.svg'),
            url: null,
            name: this.$v('通过 Facebook 继续'),
            type: 2
          },
          {
            icon: require('../../assets/img/login/mGoogle.svg'),
            name: this.$v('通过 Google 继续'),
            type: 3
          },
          {
            icon: require('../../assets/img/login/mAppleID.svg'),
            name: this.$v('通过 Apple 继续'),
            type: 4
          },
          {
            icon: require('../../assets/img/login/mTelegram.svg'),
            name: this.$v('通过 Telegram 登录'),
            type: 7
          },
          {
            icon: require('../../assets/img/login/mLinkedin.svg'),
            name: this.$v('通过 linkedIn 登录'),
            type: 8
          }
        ]
      } else if (isCn) {
        return [
          // 登录方式
          {
            icon: require('../../assets/img/login/mFacebook.svg'),
            url: null,
            name: this.$v('通过 Facebook 继续'),
            type: 2
          },
          {
            icon: require('../../assets/img/login/mGoogle.svg'),
            name: this.$v('通过 Google 继续'),
            type: 3
          },
          {
            icon: require('../../assets/img/login/mAppleID.svg'),
            name: this.$v('通过 Apple 继续'),
            type: 4
          }
        ]
      } else {
        // cn h5只有facebook apple
        return [
          // 登录方式
          {
            icon: require('../../assets/img/login/mFacebook.svg'),
            url: null,
            name: this.$v('通过 Facebook 继续'),
            type: 2
          },
          {
            icon: require('../../assets/img/login/mAppleID.svg'),
            name: this.$v('通过 Apple 继续'),
            type: 4
          }
        ]
      }
    }
  },
  created() {},
  mounted() {
    this.getTripartite() // 获取三方地址
  },
  methods: {
    yourCallbackFunction(user) {
      const that = this
      that.$api.usercenter
        .getWaistcoat(
          {
            auth_date: user.auth_date,
            first_name: user.first_name,
            hash: user.hash,
            last_name: user.last_name,
            id: user.id,
            photo_url: user.photo_url ? user.photo_url : ''
          },
          {
            HttpMethod: 'post',
            Route: 'usercenter$telegramcallback'
          }
        )
        .then((res) => {
          that.googleLogin(res)
          console.log('telegram登录', res)
        })
        .catch((err) => {
          console.log(err)
        })
      console.log(user)
    },
    async getTripartite() {
      const getThreparty = await this.$api.common
        .CV3(
          // 获取三方接口
          {},
          {
            Routes: 'usercenter$getfxwechatloginurl'
          }
        )
        .catch(() => {
          console.log('getfxwechatloginurl')
        })
      if (getThreparty && getThreparty.usercenter && getThreparty.usercenter.getfxwechatloginurl) {
        console.log('getThreparty: ', getThreparty)
        this.loginData.forEach((item) => {
          getThreparty.usercenter.getfxwechatloginurl.data.forEach((e) => {
            if (item.type == 2 && e.LoginType == 'FaceBook') item.url = e.LoginUrl
            if (item.type == 8 && e.LoginType == 'linkedIn') item.url = e.LoginUrl
          })
        })
        console.log('this.icon: ', this.icon)
        this.$forceUpdate() // 强制渲染
      }

      if (this.$store.state.myCountry != 'cn') {
        // 谷歌
        const googleSignInAPI = document.createElement('script')
        googleSignInAPI.setAttribute('src', 'https://accounts.google.com/gsi/client')
        document.head.appendChild(googleSignInAPI)
        const _that = this
        googleSignInAPI.onload = function () {
          // eslint-disable-next-line no-undef
          google.accounts.id.initialize({
            client_id: _that.clientId,
            callback: _that.OnSuccess,
            ux_mode: 'popup'
          })
          // eslint-disable-next-line no-undef
          google.accounts.id.renderButton(document.getElementById('google-login-btn-m'), {
            type: 'standard',
            theme: 'outline',
            shape: 'rectangular',
            size: 'large',
            width: 750
          })
        }
      }

      // applyid
      const applyidSignInAPI = document.createElement('script')
      applyidSignInAPI.setAttribute('src', 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js')
      document.head.appendChild(applyidSignInAPI)
      const _that = this
      applyidSignInAPI.onload = function () {
        // eslint-disable-next-line no-undef
        AppleID.auth.init({
          clientId: 'com.wikifx.web',
          scope: 'name email',
          redirectURI: `https://www${_that.$store.state.cookieHost}`,
          state: 'xcoiv98y2kd22vusuye3kch',
          // nonce : '[NONCE]',
          usePopup: true
        })
      }
      const buttonElement = document.querySelector('.appleid-signin-m')
      const that = this
      buttonElement.addEventListener('click', () => {
        // eslint-disable-next-line no-undef
        AppleID.auth
          .signIn()
          .then(function (data) {
            that.$api.usercenter
              .getWaistcoat(
                {
                  code: data.authorization.code
                },
                {
                  HttpMethod: 'get',
                  Route: 'usercenter$webapplecallback'
                }
              )
              .then((res) => {
                that.googleLogin(res)
                console.log('appleid登录', res)
              })
          })
          .catch(() => {
            console.log('apple')
          })
      })
    },
    googleLogin(res) {
      if (res.isRegister) {
        this.$nextTick(() => {
          this.setCookie(res.cookieValue)
        })
      } else {
        setTimeout(() => {
          if (process.client) {
            const href = window.location.href.substr(0, window.location.href.indexOf('?')) ? window.location.href.substr(0, window.location.href.indexOf('?')) : window.location.href
            const ulr = `?type=register&id=${res.id}&name=${res.nickName}&img=${res.img}&logintype=${res.loginType}&email=${res.email ? res.email : null}&returnurl=${href}`
            // console.log('`https:', `https://${this.$store.state.host}/${this.$store.state.LanguageCode}/login.html${ulr}`)
            window.location.href = `//${this.$store.state.host}/${this.$store.state.LanguageCode}/userlogin.html${ulr}`
            // console.log('`//${thi', `//${this.$store.state.host}/${this.$store.state.LanguageCode}/login.html${ulr}`)
          }
        }, 500)
      }
    },
    OnSuccess(resp) {
      console.log('resp: ', resp)
      this.onGoogleAuthSuccess(resp.credential)
    },
    onGoogleAuthSuccess(jwtCredentials) {
      console.log(jwtCredentials)
      this.$api.common
        .CV3(
          {
            Token: jwtCredentials
          },
          {
            Routes: 'usercenter$googlecallback'
          }
        )
        .then((res) => {
          console.log('res: ', res)
          if (res?.usercenter?.googlecallback?.data) this.googleLogin(res?.usercenter?.googlecallback?.data)
        })
    },
    setCookie(cookievalue) {
      this.$store.commit('loginClose', false)
      if (cookievalue) {
        this.$api.home.clientgetUsercookie({ contentcookie: cookievalue }).then((res) => {
          // 主账号信息
          this.$store.commit('setUser', {
            userId: res.result.userId,
            nick: res.result.nick,
            avatar: res.result.avatar,
            vest: false // 是否为马甲号
          })
        })
      }
      if (this.$store.state.host.includes('wikifx')) {
        this.CookieSet('DJkdikKMG', cookievalue, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
      } else if (this.$store.state.host.includes('fxeye')) {
        this.CookieSet('ViLartidlakd', cookievalue, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
      } else {
        this.$cookies.set('WsdsfgDGdagYms', cookievalue)
        const postdata = {
          op_type: 'setCookie',
          url: '',
          parm: cookievalue
        }
        window.parent.postMessage(postdata, '*')
      }
      const postdata = {
        op_type: 'reload',
        url: '',
        parm: ''
      }
      window.parent && window.parent.postMessage(postdata, '*')
      this.$store.commit('setUsercookie', cookievalue)
    },
    CookieSet(key, val, dom) {
      // 存cookie
      const expiresTime = new Date(Date.now() + 8.64e7 * 999)
      this.$cookies.set(key, val, {
        expires: expiresTime,
        path: '/',
        domain: dom
      })
    }
  }
}
